import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { UserApi } from '../../services/api';
import DataErk from '../util/Dialogs/DataErk';

const PrivacyCheck = () => {
    const { nutzer, isLoggedIn } = useAuth();
    const [openErk, setOpenErk] = useState(false);
    const [, setHasChecked] = useState(false);

    useEffect(() => {
        let active = true;
        const checkStatus = async () => {
            if (isLoggedIn && nutzer?.id) {
                try {
                    const response = await UserApi.checkErk(nutzer.id);
                    if (active) {
                        // Wenn nicht akzeptiert, Modal öffnen
                        if (!response.data?.hatAkzeptiert) {
                            setOpenErk(true);
                        }
                    }
                } catch (error) {
                    console.error("Fehler beim Prüfen der Datenschutzerklärung:", error);
                } finally {
                    if (active) setHasChecked(true);
                }
            } else {
                if (active) {
                    setOpenErk(false);
                    setHasChecked(false);
                }
            }
        };

        checkStatus();

        return () => {
            active = false;
        };
    }, [isLoggedIn, nutzer?.id]);

    // Wenn er nicht eingeloggt ist oder schon gecheckt wurde und kein Modal nötig ist
    if (!isLoggedIn) return null;

    return (
        <DataErk 
            openErk={openErk} 
            setOpenErk={setOpenErk} 
            mode="accept" 
        />
    );
};

export default PrivacyCheck;
